import React, { Component } from 'react';
import { ControlLabel, FormGroup, Table } from 'react-bootstrap';
import { connect } from 'react-redux';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { bindActionCreators } from 'redux';

import { generics } from 'actions';
import { USER_SETUP } from 'actions/const';

class VipMembers extends Component {
	constructor(props) {
		super(props);

		this.state = {
			isLoading: false,
		};
	}

	componentWillMount() {
		let { selectedData } = this.props;

		let { setValue } = this.props.actions;

		if (selectedData.isNew()) {
		} else {
			const isUndefined = (obj) => (typeof obj === 'undefined' ? true : false);

			this.setState({ isLoading: true });

			var vipMemberQuery = new Parse.Query('MemberToken'),
				VipHost = Parse.Object.extend(Parse.User),
				vipHost = new VipHost();
			vipHost.id = selectedData.id;

			vipMemberQuery.equalTo('vipHost', vipHost);

			vipMemberQuery
				.find()
				.then((data) => {
					const label = (obj) => {
						return !isUndefined(obj) ? obj : '';
					};

					setValue(
						USER_SETUP,
						'vipMemberList',
						data.map(
							(item) =>
								(item = {
									label:
										label(item.get('memberId')) + ' ' + label(item.get('name')),
									value: item.id,
								})
						)
					);
					this.setState({ isLoading: false });
				})
				.catch((err) => {
					this.setState({ isLoading: true });
					console.error('Get vip member error: ', err);
				});
		}
	}

	renderTr() {
		let { vipMemberList } = this.props.usersetup;

		let { setValue } = this.props.actions;

		return vipMemberList.map(({ label, value }, index) => {
			return (
				<tr key={value}>
					<td>
						{label}
						<i
							className="fa fa-times-circle fa-lg"
							style={{ float: 'right', marginTop: '2px', cursor: 'pointer' }}
							onClick={() => {
								vipMemberList.splice(index, 1);
								setValue(USER_SETUP, 'vipMemberList', vipMemberList);
							}}
						></i>
					</td>
				</tr>
			);
		});
	}

	render() {
		let { isLoading } = this.state;

		let { selectedData, loadOptions } = this.props;

		let { vipMemberList } = this.props.usersetup;

		let { setValue } = this.props.actions;

		if (isLoading) {
			return (
				<div style={{ textAlign: 'center' }}>
					<i className="fa fa-spinner fa-spin fa-3x fa-lg"></i>
				</div>
			);
		} else {
			return (
				<FormGroup>
					<ControlLabel>VIP MEMBER</ControlLabel>
					<Select.Async
						autoload={false}
						loadOptions={(input, cb) =>
							loadOptions(
								input,
								cb,
								'MemberToken',
								['memberId', 'name'],
								selectedData
							)
						}
						onChange={(val) => {
							var index = (id) =>
								vipMemberList.map(({ label, value }) => value).indexOf(id);
							console.log('index', index(val.value));
							if (index(val.value) === -1) {
								vipMemberList.push(val);
								setValue(USER_SETUP, 'vipMemberList', vipMemberList);
							}
						}}
					/>
					<br />
					<Table bordered responsive>
						<tbody>
							<tr>
								<td style={{ textAlign: 'center' }}>VIP MEMBER</td>
							</tr>
							{this.renderTr()}
						</tbody>
					</Table>
				</FormGroup>
			);
		}
	}

	componentWillUnmount() {
		let { setValue } = this.props.actions;

		setValue(USER_SETUP, 'vipMemberList', []);
	}
}

function mapStateToProps(state) {
	var { usersetup } = state;
	const props = {
		usersetup,
	};
	return props;
}

function mapDispatchToProps(dispatch) {
	const actions = {
		setValue: generics.setValue,
	};
	const actionMap = {
		actions: bindActionCreators(actions, dispatch),
	};
	return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(VipMembers);



// WEBPACK FOOTER //
// ./components/UserSetup/FormContainer/VipMembers.js